import React from "react";

import styles from "./Color.module.scss";

function Color({ color }) {
  return (
    <div
      className={styles.preview}
      style={{
        background: color,
      }}
    />
  );
}

export default Color;
